import React, { useRef, useMemo, useEffect, useState } from "react";
import { Menu } from "primereact/menu";
import { classNames } from "primereact/utils";
import Flag from "react-world-flags";
import SharedButton from "./SharedButton";
import { changeLanguage } from "i18next";
const LangSwitcher = () => {
  const langMenu = useRef(null);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("currentLang") || "en"
  );

  useEffect(() => {
    const savedLang = localStorage.getItem("currentLang") || "en";
    changeLanguage(savedLang);
    setCurrentLang(savedLang);
  }, []);

  const getCurrentFlag = () => {
    return (
      <Flag
        code={currentLang === "en" ? "US" : "SA"}
        fallback={<span>Unknown</span>}
        className="h-6 w-6"
      />
    );
  };

  const languageOptions = useMemo(
    () => [
      {
        command: () => {
          changeLanguage("en");
          setCurrentLang("en");
          localStorage.setItem("currentLang", "en");
        },
        template: (item, options) => (
          <button
            onClick={(e) => options.onClick(e)}
            className={classNames(
              options.className,
              "w-full p-link flex items-center justify-between text-[16px] py-3 px-4 text-gray-700 rounded-md hover:text-primary hover:bg-gray-200 transition-colors duration-200",
              currentLang === "en" ? "bg-gray-200 font-medium" : ""
            )}
            aria-label="Switch to English"
          >
            <div className="flex items-center">
              <Flag
                code="US"
                fallback={<span>Unknown</span>}
                className="h-5 rounded-sm shadow-sm w-5"
              />
              <span className="mx-3">English</span>
            </div>
            {currentLang === "en" && (
              <i className="text-primary pi pi-check"></i>
            )}
          </button>
        ),
      },
      {
        command: () => {
          changeLanguage("ar");
          setCurrentLang("ar");
          localStorage.setItem("currentLang", "ar");
        },
        template: (item, options) => (
          <button
            onClick={(e) => options.onClick(e)}
            className={classNames(
              options.className,
              "w-full p-link flex items-center justify-between text-[16px] py-3 px-4 text-gray-700 rounded-md hover:text-primary hover:bg-gray-200 transition-colors duration-200",
              currentLang === "ar" ? "bg-gray-200 font-medium" : ""
            )}
            aria-label="Switch to Arabic"
          >
            <div className="flex items-center">
              <Flag
                code="SA"
                fallback={<span>Unknown</span>}
                className="h-5 rounded-sm shadow-sm w-5"
              />
              <span className="mx-3">العربية</span>
            </div>
            {currentLang === "ar" && (
              <i className="text-primary pi pi-check"></i>
            )}
          </button>
        ),
      },
    ],
    [currentLang]
  );

  return (
    <div
      className={`relative `}
    >
      <div className="flex cursor-pointer items-center">
        <SharedButton
          buttonType="reset"
          icon={getCurrentFlag()}
          label={currentLang?.toUpperCase()}
          onClick={(e) => langMenu.current.toggle(e)}
          className="!h-[28px] !border-0 duration-200 gap-0 hover:bg-gray-100 transition-colors whitespace-nowrap"
          aria-label="Change language"
        />
      </div>
      <Menu
        model={languageOptions}
        popup
        ref={langMenu}
        id="popup_lang_menu"
        className="border-none shadow-lg text-14-gray !bg-gray-100 custom-menu mt-2 px-0 py-0"
        pt={{
          root: { className: "!rounded-md" },
          menuitem: { className: "border-b border-gray-200 last:border-b-0" },
          label: { className: "!text-14-dark group-hover:text-primary" },
          action: { className: "py-3 px-3 bg-gray-100 hover:bg-gray-200" },
          content: { className: "bg-transparent group !hover:rounded-md" },
          icon: { className: "text-14-dark group-hover:text-primary" },
        }}
        style={{ width: "14rem" }}
      />
    </div>
  );
};

export default LangSwitcher;
